"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Accessor_1 = require("../../models/Accessor");
var EffectiveDefinition_1 = require("../../models/EffectiveDefinition");
exports.SimplePredicateType = 'simple-predicate';
var ComparisonOperator;
(function (ComparisonOperator) {
    ComparisonOperator["EQUAL"] = "equal";
    ComparisonOperator["GREATER_THAN"] = "greater-than";
    ComparisonOperator["GREATER_THAN_OR_EQUAL"] = "greater-than-or-equal";
    ComparisonOperator["LESS_THAN"] = "less-than";
    ComparisonOperator["LESS_THAN_OR_EQUAL"] = "less-than-or-equal";
    ComparisonOperator["NOT_EQUAL"] = "not-equal";
})(ComparisonOperator = exports.ComparisonOperator || (exports.ComparisonOperator = {}));
var operatorFunc = function (operator) {
    switch (operator) {
        case ComparisonOperator.EQUAL:
            return function (lhs, rhs) { return lhs === rhs; };
        case ComparisonOperator.GREATER_THAN:
            return function (lhs, rhs) { return lhs > rhs; };
        case ComparisonOperator.GREATER_THAN_OR_EQUAL:
            return function (lhs, rhs) { return lhs >= rhs; };
        case ComparisonOperator.LESS_THAN:
            return function (lhs, rhs) { return lhs < rhs; };
        case ComparisonOperator.LESS_THAN_OR_EQUAL:
            return function (lhs, rhs) { return lhs <= rhs; };
        case ComparisonOperator.NOT_EQUAL:
            return function (lhs, rhs) { return lhs !== rhs; };
        default:
            return function (lhs, rhs) { return false; };
    }
};
exports.isSimplePredicate = function (calc) {
    return calc !== undefined && calc.type === exports.SimplePredicateType;
};
exports.simplePredicateTransformCreator = function (definition, name) {
    var column = definition.schema[name];
    if (!EffectiveDefinition_1.isCalculatedColumnSchema(column)) {
        throw new Error("Could not find calculated column with name: " + name);
    }
    var calc = column.calculation;
    if (!exports.isSimplePredicate(calc)) {
        throw new Error("Could not find simple predicate column with name: " + name);
    }
    return function (sourceTable, windowedTable) {
        return windowedTable.map(function (row) {
            var _a;
            var result = exports.applySimplePredicate(calc, row);
            return __assign(__assign({}, row), (_a = {}, _a[name] = result, _a));
        });
    };
};
exports.applySimplePredicate = function (calc, row) {
    var lhsAccessor = Accessor_1.accessorForRefOrValue(calc.lhs);
    var rhsAccessor = Accessor_1.accessorForRefOrValue(calc.rhs);
    var op = operatorFunc(calc.operator);
    return op(lhsAccessor(row), rhsAccessor(row));
};
//# sourceMappingURL=simplePredicate.js.map